import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Skeleton } from "@/components/ui/skeleton";
import type { TierInfo } from "@/lib/api/billing";
import { useSubscription, useTestMode, useTierInfo } from "@/lib/hooks/use-billing";
import { BillingContent } from "./billing-content";
import type { TenantTier } from "./types";

export default function BillingPage() {
  const navigate = useNavigate();
  const { data: tierInfo, isLoading: tierLoading } = useTierInfo();
  const { data: subscription, isLoading: subLoading } = useSubscription();

  const { data: testModeData, isLoading: testModeLoading } = useTestMode();

  const isLoading = tierLoading || subLoading || testModeLoading;
  const isEnterprise = tierInfo?.tier === "enterprise";

  useEffect(() => {
    if (isEnterprise) {
      navigate("/settings");
    }
  }, [isEnterprise, navigate]);

  if (isLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (!tierInfo || isEnterprise) return null;

  return (
    <BillingContent
      tierInfo={tierInfo as TierInfo & { tier: TenantTier }}
      subscription={subscription ?? null}
      isTestMode={testModeData?.testMode ?? false}
    />
  );
}
